import * as z from 'zod';

import { fileQuerySchema } from '../file/file-query-schema';
import { paginatedResponseSchema } from '../generic';

export const companyQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string(),
  logo: z.array(fileQuerySchema).nullish(),
  account_number: z.number().nullable(),
  state: z.string().nullish(),
});

export type CompanyQueryLinkerSchema = z.infer<typeof companyQueryLinkerSchema>;

export const companyLinkerQueryAllSchema = paginatedResponseSchema(companyQueryLinkerSchema);

export type CompanyLinkerQueryAllSchema = z.infer<typeof companyLinkerQueryAllSchema>;
